import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getPendingCourses} from "../../../../service/endpoints";

export const pendingCourseHandler = createAsyncThunk('pendingCourseHandler',async (data)=>{
    try {
        const response = await getPendingCourses(data);
        console.log(response.data,'pending courses');
        return response.data;
    } catch (error) {
        if (error.response !== undefined) {
            console.log('fail', error)
            throw error.response
        }
        else {
            console.log(error)
            throw error.response
        }
    }
})
const pendingCourseListSlice = createSlice({
    name: 'getCourses',
    initialState: {
        isLoading: false,
        data: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(pendingCourseHandler.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        });
        builder.addCase(pendingCourseHandler.pending, (state, action) => {
            state.isLoading = true
        });
        builder.addCase(pendingCourseHandler.rejected, (state, action) => {
            console.log(action.state)
            state.isError = true;
            console.log(action.payload);

        })
       
    }

});

export default pendingCourseListSlice.reducer;